import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const infoSlice = createSlice({
  name: 'info',
  initialState: {
    infoProps: {
      all: 0,
      pending: 0,
      published: 0,
      unread: 0
    },
    infoProjects: {
      all: 0,
      pending: 0,
      published: 0,
      unread: 0
    },
    statsProps: null,
    prevStatsProps: null,
    statsProjects: null,
    prevStatsProjects: null,

    propsByDay: null,
    projectsByDay: null,

    propsByMonth: {},
    projectsByMonth: {}
  },
  reducers: {
    setPropsAll: (state, action) => {
      state.infoProps.all = action.payload;
    },
    setPropsPending: (state, action) => {
      state.infoProps.pending = action.payload;
    },
    setPropsPublished: (state, action) => {
      state.infoProps.published = action.payload;
    },
    setPropsUnread: (state, action) => {
      state.infoProps.unread = action.payload;
    },
    setProjectsAll: (state, action) => {
      state.infoProjects.all = action.payload;
    },
    setProjectsPending: (state, action) => {
      state.infoProjects.pending = action.payload;
    },
    setProjectsPublished: (state, action) => {
      state.infoProjects.published = action.payload;
    },
    setProjectsUnread: (state, action) => {
      state.infoProjects.unread = action.payload;
    },
    setStatsProps: (state, action) => {
      state.statsProps = action.payload;
    },
    setPrevStatsProps: (state, action) => {
      state.prevStatsProps = action.payload;
    },
    setStatsProjects: (state, action) => {
      state.statsProjects = action.payload;
    },
    setPrevStatsProjects: (state, action) => {
      state.prevStatsProjects = action.payload;
    },
    setPropsByDay: (state, action) => {
      state.propsByDay = action.payload;
    },
    setProjectsByDay: (state, action) => {
      state.projectsByDay = action.payload;
    },
    setPropsByMonth: (state, action) => {
      state.propsByMonth = action.payload;
    },
    setProjectsByMonth: (state, action) => {
      state.projectsByMonth = action.payload;
    }
  }
});

export const {
  setPropsAll,
  setPropsPending,
  setPropsPublished,
  setPropsUnread,

  setProjectsAll,
  setProjectsPending,
  setProjectsPublished,
  setProjectsUnread,

  setStatsProps,
  setPrevStatsProps,
  setStatsProjects,
  setPrevStatsProjects,

  setPropsByDay,
  setProjectsByDay,

  setPropsByMonth,
  setProjectsByMonth
} = infoSlice.actions;

export const getAllProps =
  (realEstateId = 0, branchOfficesId) =>
  async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-props`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setPropsAll(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPendingProps =
  (realEstateId = 0, branchOfficesId) =>
  async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-pending-props`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setPropsPending(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPublishedProps =
  (realEstateId = 0, branchOfficesId) =>
  async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-published-props`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setPropsPublished(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getUnreadProps =
  (realEstateId = 0, branchOfficesId) =>
  async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-unread-props`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setPropsUnread(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getAllProjects =
  (realEstateId, branchOfficesId) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-projects`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setProjectsAll(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPendingProjects =
  (realEstateId, branchOfficesId) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-pending-projects`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setProjectsPending(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPublishedProjects =
  (realEstateId, branchOfficesId) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-published-projects`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setProjectsPublished(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getUnreadProjects =
  (realEstateId, branchOfficesId) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-unread-projects`,
        {
          realEstateId,
          branchOfficesId
        }
      );

      dispatch(setProjectsUnread(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getStatsProps =
  (branchOfficesId, typePropertiesId, date) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-by-property-statistics`,
        {
          branchOfficesId,
          typePropertiesId,
          desde: date,
          hasta: date
        }
      );

      dispatch(setStatsProps(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPrevStatsProps =
  (branchOfficesId, typePropertiesId, date) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-by-property-statistics`,
        {
          branchOfficesId,
          typePropertiesId,
          desde: date,
          hasta: date
        }
      );

      dispatch(setPrevStatsProps(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getStatsProjects =
  (branchOfficesId, typePropertiesId, date) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-by-project-statistics`,
        {
          branchOfficesId,
          typePropertiesId,
          desde: date,
          hasta: date
        }
      );

      dispatch(setStatsProjects(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPrevStatsProjects =
  (branchOfficesId, typePropertiesId, date) => async dispatch => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/statistics/count-all-by-project-statistics`,
        {
          branchOfficesId,
          typePropertiesId,
          desde: date,
          hasta: date
        }
      );
      dispatch(setPrevStatsProjects(data));
    } catch (error) {
      console.log(error);
    }
  };

export const getPropsByDay = branchOfficesId => async dispatch => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/statistics/get-properties-statistics-by-day`,
      {
        branchOfficesId
      }
    );

    dispatch(setPropsByDay(data?.response));
  } catch (error) {
    console.log(error);
  }
};

export const getProjectsByDay = branchOfficesId => async dispatch => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/statistics/get-projects-statistics-by-day`,
      {
        branchOfficesId
      }
    );

    dispatch(setProjectsByDay(data?.response));
  } catch (error) {
    console.log(error);
  }
};

export const getPropsByMonth = (branchOfficesId, year) => async dispatch => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/statistics/get-property-statistics-by-month`,
      {
        branchOfficesId,
        year
      }
    );

    dispatch(setPropsByMonth(data?.response));
  } catch (error) {
    console.log(error);
  }
};

export const getProjectsByMonth = (branchOfficesId, year) => async dispatch => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/statistics/get-project-statistics-by-month`,
      {
        branchOfficesId,
        year
      }
    );

    dispatch(setProjectsByMonth(data?.response));
  } catch (error) {
    console.log(error);
  }
};

export default infoSlice.reducer;
